import { Price } from '@hungryroot/pho';
import { Heading, Paragraph } from '@hungryroot/ramen';
import styles from './OrderSummaryTotalAmount.module.css';

interface Props {
  testid?: string;
  subtotal?: number;
  total: number;
}

export function OrderSummaryTotalAmount({ subtotal, total, testid }: Props) {
  return (
    <div data-testid={testid} className={styles['total-subtotal']}>
      {subtotal && (
        <Paragraph className={styles.total}>
          <Price testid={`${testid}-subtotal`} amount={subtotal} />
        </Paragraph>
      )}
      <Heading variant="H5">
        <Price testid={`${testid}-total`} amount={total} />
      </Heading>
    </div>
  );
}
